/* eslint-disable max-len */
export const authLinkButtonStyles =
  "w-full rounded-[8px] !py-[13px] !bg-mono-tertiary !border !border-mono-primary !text-[15px] !font-['Inter'] !text-mono-primary hover:!text-mono-primary hover:!bg-mono-secondary focus:!bg-mono-secondary whitespace-nowrap !px-0";

export const authSubmitButtonStyles =
  "w-auto rounded-[8px] !py-[13px] !bg-mono-primary border-none !text-[15px] !font-['Inter'] text-mono-white hover:!text-mono-white hover:!bg-mono-primaryLight focus:!bg-mono-primaryLight whitespace-nowrap !px-7 disabled:!bg-mono-300";

export const STRIPE_STANDARD_ONBOARDING_RETURN_PATH =
  "/v1/companies/auth/stripe/standard-return";
export const STRIPE_STANDARD_ONBOARDING_REFRESH_PATH =
  "/v1/companies/auth/stripe/standard-refresh";
export const COMPANY_STRIPE_AUTH_PATH = "/v1/companies/auth/stripe";
export const COMPANY_STRIPE_REFRESH_PATH = "/v1/companies/auth/stripe/refresh";
